import { render, staticRenderFns } from "./Format.vue?vue&type=template&id=796cb450&scoped=true"
import script from "./Format.vue?vue&type=script&lang=js"
export * from "./Format.vue?vue&type=script&lang=js"
import style0 from "./Format.vue?vue&type=style&index=0&id=796cb450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cb450",
  null
  
)

export default component.exports